<mat-sidenav-container class="sidenav-container">
	<mat-sidenav #sidenav [mode]="isMobile() ? 'over' : 'side'" [opened]="!isMobile()" class="sidenav">
		<div class="sidenav-header">
			<img src="/svgs/Mottu_verde.svg" alt="Mottu Logo" class="app-logo" />
			@if (isMobile()) {
				<button mat-icon-button (click)="sidenav.toggle()" class="menu-button">
					<mat-icon>
						<fa-icon [icon]="['fas', 'bars']"></fa-icon>
					</mat-icon>
				</button>
			}
		</div>

		<mat-nav-list>
			<div class="nav-section">
				<div class="mat-subheader">SRE PORTAL</div>

				<a (click)="isMobile() ? sidenav.close() : null" mat-list-item routerLink="/home" routerLinkActive="active">
					<div class="nav-item-content">
						<mat-icon>
							<fa-icon [icon]="['fas', 'home']"></fa-icon>
						</mat-icon>
						<span>Home</span>
					</div>
				</a>

				<a
					(click)="isMobile() ? sidenav.close() : null"
					mat-list-item
					routerLink="/ticket-classifier"
					routerLinkActive="active"
				>
					<div class="nav-item-content">
						<mat-icon>
							<fa-icon [icon]="['fas', 'ticket']"></fa-icon>
						</mat-icon>
						<span>Ticket Classifier</span>
					</div>
				</a>

				<a
					(click)="isMobile() ? sidenav.close() : null"
					mat-list-item
					routerLink="/pr-analyzer"
					routerLinkActive="active"
				>
					<div class="nav-item-content">
						<mat-icon>
							<fa-icon [icon]="['fas', 'code-pull-request']"></fa-icon>
						</mat-icon>
						<span>PR Analyzer</span>
					</div>
				</a>

				<a
					(click)="isMobile() ? sidenav.close() : null"
					mat-list-item
					routerLink="/dashboard"
					routerLinkActive="active"
				>
					<div class="nav-item-content">
						<mat-icon>
							<fa-icon [icon]="['fas', 'chart-line']"></fa-icon>
						</mat-icon>
						<span>Dashboard</span>
					</div>
				</a>
			</div>
		</mat-nav-list>

		<div class="sidenav-footer">
			<mat-divider></mat-divider>
			<div class="user-profile">
				<div class="user-info">
					<span>{{ user().name }}</span>
					<a mat-button (click)="logout()">Sair</a>
				</div>
				<div class="version">v{{ version }}</div>
			</div>
		</div>
	</mat-sidenav>

	<mat-sidenav-content>
		<mat-toolbar>
			<button mat-icon-button (click)="sidenav.toggle()" class="menu-button">
				<mat-icon>
					<fa-icon [icon]="['fas', 'bars']"></fa-icon>
				</mat-icon>
			</button>

			<div class="toolbar-content">
				<div class="toolbar-left">
					<div class="page-title-container">
						<span class="current-page">{{ title }}</span>
						<span class="subtitle">
							{{ isMobile() ? 'SRE Ops' : 'Portal de Operações SRE' }}
						</span>
					</div>
				</div>
			</div>
		</mat-toolbar>

		<div class="content">
			<router-outlet></router-outlet>
		</div>
	</mat-sidenav-content>
</mat-sidenav-container>
